// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/Fonts/N27-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/Fonts/N27-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/Images/noise_login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: N27-Bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  @font-face {
    font-family: N27-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: N27-Italic;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  @font-face {
    font-family: N27-Italic-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  @font-face {
    font-family: N27-Medium;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  .nav-bar-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height:4.875rem;
    width:100%;
    background-color: #FFFFFF;
    border-bottom: 1pt solid #9C9C9C;
   
  }
  .page-navigation-container1{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.8% 0 1% 4.4%;
    height: 2.62rem;
    width: 92.2%;
  }
  .page-navigation-container2{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 1.3% 3.6% 1% 48.4%;
    height: 3rem;
    width: 92.2%;
  }

  .nav-contributors-button{
    height:2.875rem;
    width: 9.8rem;
  }
  .nav-loginSignup-button{
    height:2.35rem;
    width: 9.5rem;
    margin-top: 0.5rem;
  }

  .nav-button-container{
    display: flex;
    height: 100%;
    width:8rem;
    margin-right: 2.5rem;
  }
  .CrsCustom-page-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .CrsCustom-container{
    display: flex;
    flex-direction: row;
    width: 92%;
    padding: 6.1% 4% 5% 4%;
    justify-content: space-between;
    align-items: center;
    height: 30.8rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    background-color: transparent;
    background-size: 100% 98%;
  }
  .left-box-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height:35rem;
    width:39rem;
    /* margin-bottom: 6.3rem; */
  }
  .left-box{
    font-family: PP-Nuebit;
    font-size: 10rem;
    text-align: left;
    /* margin-bottom: 1.5rem; */
  }
  .CrsCustom-header-container{
    display: flex;
    justify-content:flex-start;
    align-items: flex-start;
    height:3.4rem;
    width:100%;
  }
  .CrsCustom-header{
    font-family: N27-Light;
    font-size:1.55rem;
    text-align: left;
  }
  .CrsCustom-right-box-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height:108%;
    width:35rem;
    background-color: #FFFFFF;
    border: 1px solid black;
    box-shadow: 10px 10px rgb(83, 83, 83)
   }
   .CrsCustom-right-box{
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     align-items: center;
     height:100%;
     width:92%;
     padding:5.74% 4% 3.5% 4%;
   }
   .CrsCustom-content-header-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 1rem;
  }
  .CrsCustom-content-header{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .CrsCustom-header-text{
    font-family:N27-Medium;
    font-size:2.75rem;
    color: black;
    text-align: center;
    margin: 0;
  }
  .CrsCustom-description-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .CrsCustom-content-description{
    font-family:N27-Light;
    font-size:1.15rem;
    color: black;
    line-height: 150%;
    text-align:left;
    margin: 0;
  }
  .CrsCustom-input-field-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 2.75rem;

  }
  .CrsCustom-input-field {
    background-color: #f5f5f5; 
    border: none; 
    border-bottom: 2px solid black; 
    font-size: 1rem; 
    padding: 9px 20px; 
    outline: none; 
    width: 100%; 
    box-sizing: border-box;
    margin-bottom: 1rem; 
  }
  .CrsCustom-input-field::placeholder {
    color: black; 
    font-family: N27-Italic-Light ; 
  }
  .CrsCustom-input-field:focus {
    border-bottom: 2px solid #555; 
  }
  .CrsCustom-input-field .input-error { 
    background-color: #ffe5e5 !important;
    border: 2px solid #FF3B3B !important; 
    border-bottom: 2px solid #FF3B3B !important; 
    font-size: 1rem; 
    padding: 9px 20px; 
    outline: none; 
    width: 100%; 
    box-sizing: border-box;
    margin-bottom: 1rem; 
  }
  .CrsCustom-input-field .input-error::placeholder {
    color: black; 
    font-family: N27-Italic-Light ; 
  }
  .CrsCustom-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:7rem;
    width:100%;
    height:3.5rem;
  }
  .CrsCustom-button{
    cursor: pointer;
  }
  .CrsCustom-error-message-container {
    display: flex;
    padding:0rem 0 0.5rem 0.5rem;
    border: 1pt solid #FF3B3B;
    background-color: #FFF2F2;
    justify-content: space-between;
    z-index: 10;
    position: fixed;
    margin-top: 19.3rem;
    width: 33%;
  }
  .CrsCustom-error-outer-counter{
    display: flex;
    width:100%;
    justify-content: space-between;
  }
  .CrsCustom-error-container{
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .CrsCustom-eror-header-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.5rem;
  }
  .CrsCustom-info-icon{
    height:1.25rem;
    width: 1.25rem;
    margin-right: 0.5rem;
  }
  .CrsCustom-error-header{
    font-family:N27-Medium;
    font-size: 1.25rem;
    text-align: left;
    margin: 0;
    color: #F71111;
  }
  .CrsCustom-error-content-container{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 1.8rem;
    /* height:2.4rem; */
  }
  .CrsCustom-error-content{
    font-family:N27-Medium;
    font-size: 1.25rem;
    text-align: left;
    margin: 0;
    color: #3C3C3C;
  }
  .CrsCustom-x-icon-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
    margin: 0.5rem 0.5rem;
  }
  .CrsCustom-x-icon{
    height:0.729rem;
    width:0.729rem;
  }

`, "",{"version":3,"sources":["webpack://./src/components/Pages/CourseLogin/SignupCustomform.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAoD;EACtD;EACA;IACE,gBAAgB;IAChB,4CAAiD;EACnD;EACA;IACE,qBAAqB;IACrB,4CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,4CAA+C;EACjD;EACA;IACE,uBAAuB;IACvB,4CAAuD;EACzD;EACA;IACE,6BAA6B;IAC7B,4CAAqD;EACvD;EACA;IACE,uBAAuB;IACvB,4CAAgD;EAClD;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,gCAAgC;;EAElC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yDAA+D;IAC/D,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,aAAa;IACb,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB;GACD;GACA;KACE,aAAa;KACb,sBAAsB;KACtB,2BAA2B;KAC3B,mBAAmB;KACnB,WAAW;KACX,SAAS;KACT,wBAAwB;GAC1B;GACA;IACC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;;EAErB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,oCAAoC;IACpC,2CAA2C;IAC3C,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,cAAc;EAChB","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27;\n    src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n  }\n  @font-face {\n    font-family: N27-Bold;\n    src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27-Light;\n    src: url(\"../../../assets/Fonts/N27-Light.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic;\n    src: url(\"../../../assets/Fonts/N27-RegularItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Italic-Light;\n    src: url(\"../../../assets/Fonts/N27-LightItalic.otf\");\n  }\n  @font-face {\n    font-family: N27-Medium;\n    src: url(\"../../../assets/Fonts/N27-Medium.otf\");\n  }\n  .nav-bar-container{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height:4.875rem;\n    width:100%;\n    background-color: #FFFFFF;\n    border-bottom: 1pt solid #9C9C9C;\n   \n  }\n  .page-navigation-container1{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.8% 0 1% 4.4%;\n    height: 2.62rem;\n    width: 92.2%;\n  }\n  .page-navigation-container2{\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 1.3% 3.6% 1% 48.4%;\n    height: 3rem;\n    width: 92.2%;\n  }\n\n  .nav-contributors-button{\n    height:2.875rem;\n    width: 9.8rem;\n  }\n  .nav-loginSignup-button{\n    height:2.35rem;\n    width: 9.5rem;\n    margin-top: 0.5rem;\n  }\n\n  .nav-button-container{\n    display: flex;\n    height: 100%;\n    width:8rem;\n    margin-right: 2.5rem;\n  }\n  .CrsCustom-page-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .CrsCustom-container{\n    display: flex;\n    flex-direction: row;\n    width: 92%;\n    padding: 6.1% 4% 5% 4%;\n    justify-content: space-between;\n    align-items: center;\n    height: 30.8rem;\n    background-image: url('../../../assets/Images/noise_login.png');\n    background-repeat: no-repeat;\n    background-color: transparent;\n    background-size: 100% 98%;\n  }\n  .left-box-container{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    height:35rem;\n    width:39rem;\n    /* margin-bottom: 6.3rem; */\n  }\n  .left-box{\n    font-family: PP-Nuebit;\n    font-size: 10rem;\n    text-align: left;\n    /* margin-bottom: 1.5rem; */\n  }\n  .CrsCustom-header-container{\n    display: flex;\n    justify-content:flex-start;\n    align-items: flex-start;\n    height:3.4rem;\n    width:100%;\n  }\n  .CrsCustom-header{\n    font-family: N27-Light;\n    font-size:1.55rem;\n    text-align: left;\n  }\n  .CrsCustom-right-box-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height:108%;\n    width:35rem;\n    background-color: #FFFFFF;\n    border: 1px solid black;\n    box-shadow: 10px 10px rgb(83, 83, 83)\n   }\n   .CrsCustom-right-box{\n     display: flex;\n     flex-direction: column;\n     justify-content: flex-start;\n     align-items: center;\n     height:100%;\n     width:92%;\n     padding:5.74% 4% 3.5% 4%;\n   }\n   .CrsCustom-content-header-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n  .CrsCustom-content-header{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .CrsCustom-header-text{\n    font-family:N27-Medium;\n    font-size:2.75rem;\n    color: black;\n    text-align: center;\n    margin: 0;\n  }\n  .CrsCustom-description-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .CrsCustom-content-description{\n    font-family:N27-Light;\n    font-size:1.15rem;\n    color: black;\n    line-height: 150%;\n    text-align:left;\n    margin: 0;\n  }\n  .CrsCustom-input-field-container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    margin-top: 2.75rem;\n\n  }\n  .CrsCustom-input-field {\n    background-color: #f5f5f5; \n    border: none; \n    border-bottom: 2px solid black; \n    font-size: 1rem; \n    padding: 9px 20px; \n    outline: none; \n    width: 100%; \n    box-sizing: border-box;\n    margin-bottom: 1rem; \n  }\n  .CrsCustom-input-field::placeholder {\n    color: black; \n    font-family: N27-Italic-Light ; \n  }\n  .CrsCustom-input-field:focus {\n    border-bottom: 2px solid #555; \n  }\n  .CrsCustom-input-field .input-error { \n    background-color: #ffe5e5 !important;\n    border: 2px solid #FF3B3B !important; \n    border-bottom: 2px solid #FF3B3B !important; \n    font-size: 1rem; \n    padding: 9px 20px; \n    outline: none; \n    width: 100%; \n    box-sizing: border-box;\n    margin-bottom: 1rem; \n  }\n  .CrsCustom-input-field .input-error::placeholder {\n    color: black; \n    font-family: N27-Italic-Light ; \n  }\n  .CrsCustom-box{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top:7rem;\n    width:100%;\n    height:3.5rem;\n  }\n  .CrsCustom-button{\n    cursor: pointer;\n  }\n  .CrsCustom-error-message-container {\n    display: flex;\n    padding:0rem 0 0.5rem 0.5rem;\n    border: 1pt solid #FF3B3B;\n    background-color: #FFF2F2;\n    justify-content: space-between;\n    z-index: 10;\n    position: fixed;\n    margin-top: 19.3rem;\n    width: 33%;\n  }\n  .CrsCustom-error-outer-counter{\n    display: flex;\n    width:100%;\n    justify-content: space-between;\n  }\n  .CrsCustom-error-container{\n    display: flex;\n    flex-direction: column;\n    margin-top: 0.5rem;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  .CrsCustom-eror-header-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 0.5rem;\n  }\n  .CrsCustom-info-icon{\n    height:1.25rem;\n    width: 1.25rem;\n    margin-right: 0.5rem;\n  }\n  .CrsCustom-error-header{\n    font-family:N27-Medium;\n    font-size: 1.25rem;\n    text-align: left;\n    margin: 0;\n    color: #F71111;\n  }\n  .CrsCustom-error-content-container{\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-left: 1.8rem;\n    /* height:2.4rem; */\n  }\n  .CrsCustom-error-content{\n    font-family:N27-Medium;\n    font-size: 1.25rem;\n    text-align: left;\n    margin: 0;\n    color: #3C3C3C;\n  }\n  .CrsCustom-x-icon-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    cursor: pointer;\n    margin: 0.5rem 0.5rem;\n  }\n  .CrsCustom-x-icon{\n    height:0.729rem;\n    width:0.729rem;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
